module.exports = __webpack_public_path__ + "static/media/add-circle-icon-rsm.89f01a03.svg";